/**
 * Mixamo rigs arrive under several spellings of the same skeleton:
 * "mixamorig:Hips" straight from Mixamo, "mixamorigHips" after three's
 * GLTFLoader strips the reserved colon, "mixamorig1_Hips" when a DCC tool has
 * renamed a second import. Normalising to a bare lowercase bone name lets
 * clips from any of them bind to any of them.
 */
const NAMESPACE = /^mixamorig\d*[:_\-\s]*/i;

export function normalizeBoneName(name) {
  return String(name).replace(NAMESPACE, '').replace(/[^a-z0-9]/gi, '').toLowerCase();
}

/** Map of normalized name -> the bone's actual name, for a skeleton's bones. */
export function boneNameIndex(bones) {
  const index = new Map();
  for (const bone of bones) {
    const key = normalizeBoneName(bone.name);
    // First bone wins: a duplicate normally means a helper bone copied the name.
    if (key && !index.has(key)) index.set(key, bone.name);
  }
  return index;
}
